import { Component, OnInit, Input } from '@angular/core';
import { MapboxDataService } from '@sdk/services/map-box-data/mapbox-data.service';
import { ICardAforoModel } from '@types-custom/models/ui/card-aforo-model';
import { ITimeLineGraphicModel } from '@types-custom/models/ui/chart-line-color-model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { ISpeedometerModel } from '@types-custom/models/ui/speedometer-model';
import { DrawerPanelService } from '@ui-core/services/drawer-panel/drawer-panel.service';

@Component({
  selector: 'panel-aforo',
  templateUrl: './panel-aforo.component.html',
  styleUrls: ['./panel-aforo.component.scss'],
})
export class PanelAforoComponent implements OnInit {
  @Input() cards: ICardAforoModel[] = [];
  @Input() serviceDataSource: any;

  card_list: any
  full_card_list: any[] = [];
  searchText = '';
  Icon = Icon;

  avgSpeedProps: ISpeedometerModel = {
    chartType: 4,
    divId: 'avgSpeed',
    descriptionLabel: 'Velocidad promedio',
    unitLabel: 'Km/h',
    value: 0,
  };

  carsFlowIndicator = 0;
  vehicleCount = 0;
  motorcycleCount = 0;
  pedestrianCount = 0;
  activeCameraCount = 0;
  cameraCount = 0;
  inactiveCameraCount = 0;
  flowCountdataGraphicList: ITimeLineGraphicModel;
  flowCountcolorScale: any = [{}];
  avgSpeeddataGraphicList: ITimeLineGraphicModel;
  avgSpeedcolorScale: any = [{}];

  constructor(
    private drawerPanelService: DrawerPanelService,
    private mapDataService: MapboxDataService,
  ) { }

  ngOnInit(): void {
    this.serviceDataSource.getPanelAforoMeasurements().subscribe((res: any) => {
      this.setPanelData(res);
    });
  }

  setPanelData(response: any): void {
    this.carsFlowIndicator = response.count;
    this.vehicleCount = response.vehicleCount || 0;
    this.motorcycleCount = response.motorcycleCount || 0;
    this.pedestrianCount = response.pedestrianCount || 0;
    this.activeCameraCount = response.activeCameraCount || 0;
    this.cameraCount = response.cameraCount || 0;
    this.inactiveCameraCount = response.inactiveCameraCount || 0;
    this.avgSpeedProps.value = response.speedAverage.toFixed(2)
    this.full_card_list = response.groupCameras.reduce((acc: any, crr: any) => {
      const { cameraId, cameraName, date, speedAverage, count } = crr;
      const existingEntry = acc.find((entry: any) => entry.cameraId === cameraId);
      if (existingEntry) {
        existingEntry.speed += speedAverage;
        existingEntry.count += count;
      } else {
        acc.push({ cameraId, cameraName, date, speedAverage, count });
      }

      return acc;
    }, []);
    this.full_card_list.forEach((e: any) => {
      e.date = e.date.replace('T', ' - ')
    });
    this.card_list = [...this.full_card_list];


    // this.setAforoIndicators(response);
    // this.graphicFlowCountChartLine(response.avgCountAndSpeed);
    // this.graphicAvgSpeedChartLine(response.avgCountAndSpeed);
    // this.setRuntGrid(response.grid);
  }

  graphicFlowCountChartLine(dataChartLine: any[]): void {
    const dataGraphic = dataChartLine.map((element: any) => {
      return {
        time: element.time,
        value: element.count,
      };
    });
    this.flowCountdataGraphicList = {
      data: dataGraphic,
      label: '',
      labelX: 'Hora',
      // labelY: 'Conteo de Vehículos',
      labelY: '',
    };
    this.flowCountcolorScale = [
      { minValue: 0, maxValue: 10000, color: '#00FFC266' },
    ];
  }

  graphicAvgSpeedChartLine(dataChartLine: any[]): void {
    const dataGraphic = dataChartLine.map((element: any) => {
      return {
        time: element.time,
        value: element.speed,
      };
    });
    this.avgSpeeddataGraphicList = {
      data: dataGraphic,
      label: 'Km/h',
      labelX: 'Hora',
      // labelY: 'Velocidad media Km/h',
      labelY: '',
    };
    this.avgSpeedcolorScale = [
      { minValue: 0, maxValue: 10000, color: '#4992FF' },
    ];
  }

  setAforoIndicators(indicators: any) {
    let sumAvgSpeed = 0;
    let sumFlowCount = 0;
    let count = 0;


    for (const indicator of indicators) {
      if (!isNaN(+indicator.count)) {
        sumFlowCount += +indicator.count;
      }

      if (!isNaN(+indicator.speed) && indicator.speed !== 0) {
        sumAvgSpeed += +indicator.speed;
        count++;
      }
    }

    this.avgSpeedProps.value = count ? Math.round(sumAvgSpeed / count) : 0;
    this.carsFlowIndicator = sumFlowCount;
  }

  // private setRuntGrid(data: any) {
  //   this.cards.map((card) => {
  //     data.map((item: any) => {
  //       if (card.cameraId === item.cameraId) {
  //         card.speed = item.avgSpeed;
  //         card.count = item.totalCount;
  //       }
  //     });
  //   });
  // }

  isSearchFocused = false;

  onSearchInput(event: any): void {
    this.searchText = event.target.value;
    this.filterCameras();
  }

  onFocus(): void {
    this.isSearchFocused = true;
  }

  onBlur(): void {
    setTimeout(() => {
      this.isSearchFocused = false;
    }, 200);
  }

  clearSearch(): void {
    this.searchText = '';
    this.filterCameras();
  }

  filterCameras(): void {
    const text = this.searchText.toLowerCase();
    this.card_list = this.full_card_list.filter((card: any) => {
      return card.cameraName.toLowerCase().includes(text);
    });
  }

  openModal(card: any): void {
    if (!card) return;
    this.serviceDataSource.getCameraInfoByName(card.cameraName).subscribe((data: any) => {
      if (!data) return;
      this.mapDataService.lineclick({
        event: { features: [{ properties: data }] },
        layer: 'AforoModel'
      })
    });
  }
}
